import socialSecurity from './socialSecurity/socialSecurity';

let socialSecurityFeatures = angular.module('social-security.features', [
  socialSecurity
])
  .name;

export default socialSecurityFeatures;



// WEBPACK FOOTER //
// ./client/app/social-security.module/features/social-security.features.js